import { AsyncPipe, DatePipe } from "@angular/common";
import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { ButtonComponent } from "@components/button/button.component";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { BlockComponent } from "@components/container-block/block.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { PageComponent } from "@components/page/page.component";
import { Subscription, timer } from "rxjs";
import { repeat, skip, take, takeUntil } from "rxjs/operators";
import { BusyService } from "~app/common/components/busy/busy.service";
import { JobbDTO } from "./jobb.models";
import { JobbService } from "./jobb.service";

@Component({
    selector: "rask-jobb",
    templateUrl: "./jobb.component.html",
    styleUrls: ["./jobb.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        BlockComponent,
        ButtonComponent,
        CheckboxComponent,
        ListComponent,
        ListColumnDirective,
        RouterLink,
        AsyncPipe,
        DatePipe
    ]
})
export class JobbComponent implements OnInit, OnDestroy {
    protected readonly service = inject(JobbService);

    protected jobbLista: JobbDTO[];
    protected secondsPassed = 0;
    protected secondDelay = 30;
    protected latestRefresh = new Date();
    private readonly busyService = inject(BusyService);
    private readonly subscriptions: Subscription[] = [];

    ngOnDestroy(): void {
        this.unsubscribeAutoRefresh();
    }

    ngOnInit(): void {
        this.refresh();
        this.service.currentjobb$.subscribe(x => {
            this.jobbLista = x;
            this.latestRefresh = new Date();
        });
        this.service.autoRefreshActive$.pipe(take(1)).subscribe(autoRefresh => {
            this.updateAutoRefreshState(autoRefresh);
        });
    }

    onAutoRefreshChange($event): void {
        this.service.toggleAutoRefresh($event);
        this.updateAutoRefreshState($event);
    }

    protected refresh(): void {
        this.busyService.addWork(this.service.refreshJobb()).subscribe();
    }

    private updateAutoRefreshState(active: boolean) {
        // eslint-disable-next-line sonarjs/no-selector-parameter
        if (active) {
            this.subscribeAutoRefresh();
        } else {
            this.unsubscribeAutoRefresh();
        }
    }

    private subscribeAutoRefresh() {
        const intervalSource = timer(0, 1000);

        const reloadSource = intervalSource.pipe(
            skip(this.secondDelay),
            take(1),
            repeat()
        );

        this.addSubscription(reloadSource.subscribe(_ => {
            this.refresh();
        }));

        this.addSubscription(intervalSource.pipe(
            takeUntil(reloadSource),
            repeat()
        ).subscribe(secondsPassed => {
            this.secondsPassed = secondsPassed;
        }));

    }

    private addSubscription(subscription: Subscription) {
        this.subscriptions.push(subscription);
    }

    private unsubscribeAutoRefresh(): void {
        this.subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }

}
